import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import axiApi from "ApiCaller";
import {SwalAlertClass} from "core/swalClass";
import FormButton from "components/buttons/FormButton";
import FormTabProgTasks from "./FormTabProgTasks";
import FormTabTaskSelection from "./FormTabTaskSelection";

const FormProgTasks = ({item, setItem, setShowCanvas, showCanvas, fetchTasks,}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tr} = useTranslation("routes");

    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const [keyTab, setKeyTab] = useState("programming");
    const [isLoading, setIsLoading] = useState(false);
    const [days, setDays] = useState([]);
    const [optionsShown, setOptionsShown] = useState([]);
    const [option, setOption] = useState("0");

    const inputRefs = useRef({name: null});

    useEffect(() => {
        setOption("0");
        setOptionsShown([]);
        setDays([]);
    }, [item.id]);


    const handleClose = () => setShowCanvas(false);

    const handleSubmit = () => {
        setKeyTab("programming");
        if (!item || !item.name) {
            Alert.warning("Falta dato obligatorio", "Es necesario un Nombre").then(() => {
                inputRefs.current.name && inputRefs.current.name.focus();
            });
            return;
        }

        let values = {};
        if (item && item.is_periodic) {
            switch (item.repeat) {
                case "w":
                    values = {days};
                    break;
                case "m":
                case "y":
                    values = optionsShown.find((o) => o.id === option) || {};
                    break;
                default:
            }
        }

        setIsLoading(true);

        const itm = item || {};
        const payload = {
            id: itm.id || null,
            name: itm.name,
            description: itm.description || "",
            type: itm.type || "p",
            is_periodic: !!itm.is_periodic,
            every: itm.every || 1,
            repeat: itm.repeat || "d",
            date_start: itm.date_start || null,
            date_end: itm.date_end || null,
            compile: itm.compile || null,
            run: itm.run || null,
            values,
            tasks: Array.isArray(itm.tasks)
                ? itm.tasks.map((t) => (t && (t.id !== undefined ? t.id : t.value !== undefined ? t.value : t)))
                : [],
        };

        axiApi
            .post("/api/maint/progtasks/add/", payload)
            .then((resp) => {
                if (resp.data && resp.data.status) {
                    if (typeof fetchTasks === "function") fetchTasks();
                    setShowCanvas(false);
                    Alert.info("Guardado", "Se ha guardado correctamente");
                } else {
                    Alert.error("Error al guardar", resp.data?.message || "Consultar con el administrador");
                }
            })
            .catch((err) => {
                console.error(err);
                Alert.error("Error servidor", "Consultar con el administrador");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <Offcanvas
            show={showCanvas}
            onHide={handleClose}
            placement="end"
            backdrop="static"
            style={{width: "40%", fontSize: "15px"}}>
            <Offcanvas.Header className="preview-canvas">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="wrench" />
                </div>
                <div className="preview-title">
                    <Offcanvas.Title>{_Tr("labels.tasks")}</Offcanvas.Title>
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body className="pt-0" style={{fontSize: "13px"}}>
                <div className="col-12">
                    <Tabs
                        activeKey={keyTab}
                        id="form-progtasks-tabs"
                        onSelect={(k) => setKeyTab(k)}
                        className="mb-3 mt-1"
                        justify>
                        <Tab eventKey="programming" title={_Tr("labels.programming")}>
                            <FormTabProgTasks
                                item={item}
                                setItem={setItem}
                                days={days}
                                setDays={setDays}
                                optionsShown={optionsShown}
                                setOptionsShown={setOptionsShown}
                                option={option}
                                setOption={setOption}
                                inputRefs={inputRefs}
                            />
                        </Tab>
                        <Tab eventKey="tasks" title={_Tr("labels.tasks")}>
                            <FormTabTaskSelection item={item} setItem={setItem} />
                        </Tab>
                    </Tabs>
                </div>

                <div className="p-3 buttons-footer">
                    <div className="position-fixed bottom-0 end-0 mb-3 me-5">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>
                            {_Tf("labels.cancel")}
                        </button>
                        <FormButton
                            label="Guardar"
                            className="btn btn-primary ms-4"
                            isProcessing={isLoading}
                            onClick={handleSubmit}>
                            {_Tf("labels.save")}
                        </FormButton>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default FormProgTasks;
